import React, { Component } from 'react';
import { UserContext } from '../userContext/UserContext';
import './WelcomeUser.css';

class WelcomeUser extends Component {
    static contextType = UserContext; // Use the UserContext to access user data

    render() {
        const { userName } = this.context; // Get the user's name from context
        return (
            <div className="welcome-user">
                {userName ? `Welcome, ${userName}` : 'Welcome, Guest'}
            </div>
        );
    }
}

export default WelcomeUser;
